// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","container":"Posts_container__3Cqib","container_tiles":"Posts_container_tiles__2SEEV","post":"Posts_post__1OnA_"};